export type DateFieldSectionsState = 'empty' | 'partial' | 'complete';

/**
 * MUI only fires onError for fully-typed illegal dates. A partially filled
 * field (e.g. 07/05/YYYY) yields a null value and no error, so inspect the
 * rendered sections. Empty sections are spinbuttons without aria-valuenow;
 * a fully empty field renders a single non-spinbutton placeholder.
 *
 * @param container - Any element containing the field's rendered sections (e.g.
 * the `currentTarget` of a text field slot's onBlur/onFocus).
 */
export function getSectionsState(container: Element): DateFieldSectionsState {
  const sections = [...container.querySelectorAll('[role="spinbutton"]')];
  const filled = sections.filter((el) => el.hasAttribute('aria-valuenow')).length;
  if (sections.length === 0 || filled === 0) return 'empty';
  return filled < sections.length ? 'partial' : 'complete';
}

/**
 * Blur events bubble from each section, so moving between sections of the same
 * field also triggers them. True only when focus really left the field.
 */
export function isBlurLeavingField(event: {
  currentTarget: Element;
  relatedTarget: EventTarget | null;
}): boolean {
  const { currentTarget, relatedTarget } = event;
  return !(relatedTarget instanceof Node && currentTarget.contains(relatedTarget));
}
